var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.197,
    height: 22.197,
    viewBox: "0 0 22.197 22.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-warning",
    "data-name": "Icon metro-warning",
    d: "M13.669,3.939l9.3,18.538H4.368l9.3-18.538Zm0-2.011a1.6,1.6,0,0,0-1.32.968L2.875,21.779c-.726,1.29-.108,2.346,1.372,2.346H23.091c1.481,0,2.1-1.056,1.372-2.346h0L14.989,2.9a1.6,1.6,0,0,0-1.32-.968Zm1.387,18.035a1.387,1.387,0,1,1-1.387-1.387A1.387,1.387,0,0,1,15.056,19.963Zm-1.387-2.775A1.387,1.387,0,0,1,12.282,15.8V11.639a1.387,1.387,0,0,1,2.775,0V15.8A1.387,1.387,0,0,1,13.669,17.188Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#dc083a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.56c3d3e0a4b31fc5a86c9ca5502dd8b9.svg";
export { ForwardRef as ReactComponent };